import { useState } from "react";
import styled from "styled-components";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import { showToast } from "../Utils/variables";
import AlarmApplyBox from "./AlarmApply";

const DonationCompleteBox = ({ type, handleClickX, handleComplete }) => {
  const [clickApply, setClickApply] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [clickInput, setClickInput] = useState(false);

  const handleInputChange = (e) => {
    const value = e.target.value.replaceAll(",", "");
    if (!isNaN(value)) {
      setInputValue(formatNumber(value));
    }
  };

  const setMoneyValue = (value) => {
    value = value.replaceAll(",", "");
    if (!isNaN(value)) {
      return Number(value);
    }

    return null;
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat().format(value);
  };

  const [clickActive, setClickActive] = useState(false);
  const handleBlur = () => {
    const moneyValue = setMoneyValue(inputValue);
    setClickActive(Number.isInteger(moneyValue) && moneyValue > 0);
    setClickInput(false);
  };

  const handleOpenApplyModal = () => {
    const moneyValue = setMoneyValue(inputValue);

    if (!Number.isInteger(moneyValue) || moneyValue <= 0) {
      showToast("기부 금액을 1원 이상 입력해주세요.", "error");
      return;
    }

    setClickApply(true);
  };

  return (
    <div>
      {clickApply && (
        <AlarmApplyBox
          title="기부 완료 처리를 진행하시겠습니까?"
          handleClickX={() => {
            setClickApply(false);
          }}
          handleApply={() => handleComplete(setMoneyValue(inputValue))}
        />
      )}
      <Box>
        <div className="center">
          <p className="bold-text" style={{ fontSize: "20px" }}>
            기부 완료 {type ? "수정" : "등록"}
          </p>
        </div>
        <div className="center">
          <p style={{ marginTop: "10px" }}>
            걸음수를 바탕으로 최종적으로 기부한 금액을 입력해주세요.
          </p>
        </div>
        <InputArea clickInput={clickInput}>
          <input
            placeholder="기부한 금액을 입력해주세요."
            value={inputValue}
            onChange={handleInputChange}
            onBlur={handleBlur}
            onClick={() => setClickInput(true)}
          />
          <p>원</p>
        </InputArea>

        <p className="info-text" style={{ marginTop: "10px" }}>
          · 기부 완료 처리 시 해당 금액이 앱 화면에 ‘직전 기부 금액’ 으로
          노출됩니다.
        </p>
        <p className="info-text">
          · 직전 기부 금액은 다음 기부 전까지 계속 노출됩니다.
        </p>

        <div className="hrz-wrapper" style={{ marginTop: "30px", gap: "14px" }}>
          <div
            className="blueBorderBtn-base center"
            style={{ width: "243px", height: "60px", borderRadius: "10px" }}
            onClick={handleClickX}
          >
            취소
          </div>
          <div
            className="blueBtn-base"
            style={{
              width: "243px",
              height: "60px",
              borderRadius: "10px",
              backgroundColor: clickActive ? "#1167ed" : "#b0b0b0",
            }}
            onClick={handleOpenApplyModal}
          >
            확인
          </div>
        </div>
      </Box>
    </div>
  );
};

const Box = styled.div`
  width: auto;
  height: auto;
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  .info-text {
    margin-top: 4px;
    font-size: 14px;
    color: #888888;
  }
`;
const InputArea = styled.div`
  width: 500px;
  height: 60px;
  margin-top: 30px;
  border-bottom: 2px solid
    ${(props) => (props.clickInput ? "#1167ed" : "#e4e4e4")};
  display: flex;
  align-items: center;
  > input {
    width: 437px;
    margin-left: 14px;
    color: #222222;
    font-size: 20px;
    border: none;
    &:focus {
      outline: none;
    }
    &::placeholder {
      font-size: 20px;
      color: #888888;
    }
  }
  > p {
    margin-left: auto;
    margin-right: 14px;
    font-family: "notoSans-medium";
  }
`;

const DonationComplete = ({ type = null, handleClickX, handleComplete }) => {
  return (
    <LayoutModal
      Modal={
        <DonationCompleteBox
          type={type}
          handleClickX={handleClickX}
          handleComplete={handleComplete}
        />
      }
    />
  );
};

export default DonationComplete;
